// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2PnOk","subheader":"ReorderModal_subheader__22Suw","listWrap":"ReorderModal_listWrap__1wuAb"};